import React from 'react';
import { Icon } from './Icon.js';
export const IconChatBubbleLock = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M22 6H14V11H22V6Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M20 6V4C20 2.89543 19.1046 2 18 2C16.8954 2 16 2.89543 16 4V6", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("path", { d: "M10 4L2 4V22H4L6.25 18H22V15", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", "data-color": "color-2", fill: "none" })));
};
//# sourceMappingURL=IconChatBubbleLock.js.map